import { z } from "zod";
import { LOT_STATUSES, TRANSPORT_KINDS, type LotStatus, type TransportKind } from "./enums";

/** Форма создания/редактирования лота (раздел 4 требований). */
export const lotInputSchema = z.object({
  projectId: z.string().uuid(),
  transportKind: z.enum(TRANSPORT_KINDS),
  loadingAddress: z.string().min(3),
  loadingAt: z.coerce.date(),
  intermediateAddresses: z.array(z.string().min(1)).default([]),
  unloadingAddress: z.string().min(3),
  vehicleTypeId: z.string().uuid(),
  weightKg: z.number().int().positive(),
  lengthM: z.number().positive(),
  widthM: z.number().positive(),
  heightM: z.number().positive(),
  placesCount: z.number().int().positive().nullable().default(null),
  cargoName: z.string().min(1),
  cargoDescription: z.string().default(""),
  specialConditions: z.string().default(""),
  insurance: z.string().default(""),
  contactUserId: z.string().uuid().nullable().default(null),
  deadlineAt: z.coerce.date(),
  autoExtend: z.boolean().default(false),
});
export type LotInput = z.infer<typeof lotInputSchema>;

/** Карточка лота в списке портала. Авторы ставок сюда никогда не попадают. */
export const lotListItemSchema = z.object({
  id: z.string().uuid(),
  number: z.string(),
  status: z.enum(LOT_STATUSES),
  projectName: z.string(),
  transportKind: z.enum(TRANSPORT_KINDS),
  loadingAddress: z.string(),
  unloadingAddress: z.string(),
  loadingAt: z.string(),
  vehicleTypeName: z.string(),
  weightKg: z.number(),
  deadlineAt: z.string(),
  autoExtend: z.boolean(),
  autoExtensionsUsed: z.number(),
  currentMinAmount: z.number().nullable(),
  bidsCount: z.number(),
  createdByName: z.string(),
});
export type LotListItem = z.infer<typeof lotListItemSchema>;

/** Фильтры списка заявок (16.3) — параметры GET /api/lots и состояние панели фильтров в URL. */
export type LotListQuery = {
  /** Не задано — статусы по умолчанию (DEFAULT_LOT_LIST_STATUSES). */
  status?: LotStatus[];
  projectId?: string;
  transportKind?: TransportKind;
  /** Календарные даты YYYY-MM-DD в поясе приложения. */
  loadingFrom?: string;
  loadingTo?: string;
  createdBy?: string;
  /** Поиск по номеру, адресам погрузки/выгрузки и наименованию груза. */
  q?: string;
};

/** По умолчанию в списке всё, кроме оплаченных и отменённых. */
export const DEFAULT_LOT_LIST_STATUSES: LotStatus[] = LOT_STATUSES.filter((s) => s !== "paid" && s !== "cancelled");

/** GET /api/dictionaries/users — для фильтра «Автор». */
export type UserOption = { id: string; fullName: string; isActive: boolean };

export const extendLotSchema = z.object({
  deadlineAt: z.coerce.date(),
  reason: z.string().min(1),
});

export const cancelLotSchema = z.object({
  reason: z.string().min(1),
});
